
import { lazy, Suspense } from 'react';
import HeroContent from './HeroContent';
import HeroStats from './HeroStats';
import GlitchStyles from './GlitchStyles';

// Lazy load heavy components
const ServicesSection = lazy(() => import('./ServicesSection'));
const HeroVideo = lazy(() => import('./HeroVideo'));
const TechBackground = lazy(() => import('./TechBackground'));

const HeroSection = () => {
  return (
    <section id="home" className="hero-section pt-16 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden section-float">
      {/* Tech Background - Lazy loaded */}
      <Suspense fallback={null}>
        <TechBackground />
      </Suspense>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="space-y-8">
            {/* This should be the LCP element - load immediately */}
            <HeroContent />
            <HeroStats />
          </div>

          {/* Video - Lazy loaded with loading state */}
          <div className="relative">
            <Suspense fallback={
              <div className="relative w-full h-0 pb-[56.25%] rounded-2xl overflow-hidden shadow-2xl bg-gray-200 animate-pulse">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-gray-500 text-sm">Loading video...</div>
                </div>
              </div>
            }>
              <HeroVideo />
            </Suspense>
          </div>
        </div>

        {/* Services Section - Lazy loaded */}
        <div className="services-scroll-target">
          <Suspense fallback={
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 animate-pulse">
                  <div className="w-12 h-12 bg-gray-200 rounded-lg mb-4"></div>
                  <div className="h-6 bg-gray-200 rounded mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                </div>
              ))}
            </div>
          }>
            <ServicesSection />
          </Suspense>
        </div>
      </div>

      <GlitchStyles />
    </section>
  );
};

export default HeroSection;
